// User preferences utility for managing settings

const USER_PROFILE_KEY = 'smartreadgo_user_profile';
const USER_PREFERENCES_KEY = 'smartreadgo_preferences';

export const saveUserProfile = (profile) => {
  try {
    localStorage.setItem(USER_PROFILE_KEY, JSON.stringify(profile));
    return { success: true, message: 'Profile saved successfully' };
  } catch (error) {
    console.error('Error saving profile:', error);
    return { success: false, message: 'Failed to save profile' };
  }
};

export const getUserProfile = () => {
  try {
    const stored = localStorage.getItem(USER_PROFILE_KEY);
    if (!stored) {
      return {
        name: '',
        age: '',
        mobile: '',
        email: ''
      };
    }
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error getting profile:', error);
    return {
      name: '',
      age: '',
      mobile: '',
      email: ''
    };
  }
};

export const saveUserPreferences = (preferences) => {
  try {
    localStorage.setItem(USER_PREFERENCES_KEY, JSON.stringify(preferences));
    return { success: true };
  } catch (error) {
    console.error('Error saving preferences:', error);
    return { success: false };
  }
};

export const getUserPreferences = () => {
  try {
    const stored = localStorage.getItem(USER_PREFERENCES_KEY);
    if (!stored) {
      return {
        notifications: true,
        darkMode: false
      };
    }
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error getting preferences:', error);
    return {
      notifications: true,
      darkMode: false
    };
  }
};

export const clearUserData = () => {
  try {
    localStorage.removeItem(USER_PROFILE_KEY);
    localStorage.removeItem(USER_PREFERENCES_KEY);
    return { success: true };
  } catch (error) {
    console.error('Error clearing user data:', error);
    return { success: false };
  }
};